<template>
  <div class="container">
    <slot name="header"></slot>
    <slot></slot>
    <slot name="footer"></slot>
  </div>
</template>
<script setup lang="ts">
type Props = {
  headerDivider?: boolean
}

defineProps<Props>()
</script>
<style lang="scss" scoped>
@use '@/design-system/design-tokens/font-mixins';
@use '@/design-system/design-tokens/variables.scss';
.container {
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  background-color: variables.$color-pure-white;
}
</style>
